// extracted by mini-css-extract-plugin
module.exports = {"menu_item":"menu-item_menu_item__9rnmi","error":"menu-item_error__4Xoco","prefix":"menu-item_prefix__iOVXr","suffix":"menu-item_suffix__Q2_3_"};